export { default as DeletePortfolio } from './component';
